import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ActivityMonitorService } from "@apps/patient-core/src/app/services/activity-monitor.service";
import { MINUTE_IN_S } from "@shared/time-constants";
import { Epoch } from "@shared/time-utils";
import { ConciergeLoginService } from "./concierge-login.service";
import { ConciergeDataService } from "./concierge-data.service";

export const INACTIVITY_TIMEOUT_THRESHOLD = MINUTE_IN_S * 2;

@Injectable({
  providedIn: "root",
})
export class ConciergeLogoutService {
  constructor(
    private _router: Router,
    private _activityMonitorService: ActivityMonitorService,
    private _conciergeLoginService: ConciergeLoginService,
    private _conciergeDataService: ConciergeDataService
  ) {}

  public onAppLoaded(): void {
    if (!this._conciergeDataService.hasConciergeData()) {
      return;
    }

    this._onAppRestored();

    this._conciergeLoginService.onLogout.subscribe(() => {
      this._activityMonitorService.clear();
    });
  }

  public onAppVisibilityChange(visibilityState: "visible" | "hidden"): void {
    if (this._router.url === "/" || visibilityState === "hidden") {
      // Ignore the initial page load visibility change and hidden state
      return;
    }

    this._onAppRestored();
  }

  private _onAppRestored(): void {
    const inactivityTime = Epoch.seconds.fromMilliseconds(Date.now() - this._activityMonitorService.lastActivity);

    if (inactivityTime > INACTIVITY_TIMEOUT_THRESHOLD) {
      this._activityMonitorService.clear();

      void this._conciergeLoginService.logoutPatientInPractice("inactivity");
    }
  }
}
